export default [
  {
    path: "/application/settings",
    name: "application-settings",
    component: () => import("@/views/application-settings/ApplicationEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "App" },
        { title: "Settings", active: true }
      ],
      pageTitle: "Configurações do Aplicativo",
      rule: "admin"
    }
  }
];

